import http from "../utils/http";

export default {
    signin(data, fun) {
        http.post("/auth/signin", data, fun)
    }, 
    userInfo(fun,backFun) {
        http.get("/auth/userinfo",{}, fun,backFun)
    },
    signOut(fun) {
        http.delete("/auth/signout",fun)
    }
}